export enum EAlertVariant {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
}
